import Country from 'country-state-city/lib/country';
import State from 'country-state-city/lib/state';

export type AddressLocation = { country: string; state: string };

export const getCountryOptions = () => {
  const countries = Country.getAllCountries();
  const unitedStates = countries.find(country => country.isoCode === 'US');

  return [
    ...(unitedStates ? [unitedStates] : []),
    ...countries.filter(country => country.isoCode !== 'US'),
  ].map(country => ({ value: country.isoCode, label: country.name }));
};

export const getStateOptions = (countryCode: string) =>
  State.getStatesOfCountry(countryCode).map(state => ({
    value: state.name,
    label: state.name,
  }));

export const getCountryName = (countryCode: string) =>
  Country.getCountryByCode(countryCode)?.name ?? null;

export function resolveAddressLocation(
  countryValue?: string | null,
  stateValue?: string | null,
): AddressLocation {
  const normalizedCountry = countryValue?.trim().toLowerCase();
  const normalizedState = stateValue?.trim().toLowerCase();
  const country = normalizedCountry
    ? Country.getAllCountries().find(
        item =>
          item.isoCode.toLowerCase() === normalizedCountry ||
          item.name.toLowerCase() === normalizedCountry,
      )
    : undefined;

  if (!normalizedState) return { country: country?.isoCode ?? '', state: '' };

  const matchingStates = State.getAllStates().filter(
    state =>
      state.isoCode.toLowerCase() === normalizedState ||
      state.name.toLowerCase() === normalizedState,
  );
  const state =
    matchingStates.find(item => item.countryCode === country?.isoCode) ??
    matchingStates.find(item => item.countryCode === 'US') ??
    matchingStates[0];

  return state
    ? { country: state.countryCode, state: state.name }
    : { country: country?.isoCode ?? '', state: stateValue?.trim() ?? '' };
}
